import { render, staticRenderFns } from "./remoteControl.vue?vue&type=template&id=2c90df5e&scoped=true&"
import script from "./remoteControl.vue?vue&type=script&lang=js&"
export * from "./remoteControl.vue?vue&type=script&lang=js&"
import style0 from "./remoteControl.vue?vue&type=style&index=0&id=2c90df5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90df5e",
  null
  
)

export default component.exports